import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../shared/services/app-config.service';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
var ProjectsService = /** @class */ (function () {
    function ProjectsService(http, crazyCallConfigService, appConfigService) {
        this.http = http;
        this.crazyCallConfigService = crazyCallConfigService;
        this.appConfigService = appConfigService;
    }
    Object.defineProperty(ProjectsService.prototype, "projectsUrl", {
        get: function () {
            return "" + this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + this.crazyCallConfigService.appId + "/projects";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "projectsWithStatsUrl", {
        get: function () {
            return "" + this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + this.crazyCallConfigService.appId + "/projects-stats";
        },
        enumerable: true,
        configurable: true
    });
    ProjectsService.prototype.projectsWithStats = function () {
        return this.http.get(this.projectsUrl + "/with-stats");
    };
    ProjectsService.prototype.allProjects = function () {
        return this.http.get(this.projectsUrl);
    };
    ProjectsService.prototype.singleProject = function (projectId) {
        return this.http.get(this.projectsUrl + "/" + projectId);
    };
    ProjectsService.prototype.checkIfNameExists = function (name) {
        return this.http.get(this.projectsUrl + "/exists", { params: { name: name } });
    };
    ProjectsService.prototype.changeActivity = function (projectId, active) {
        return this.http.put(this.projectsUrl + "/" + projectId + "/activity", {}, { params: { active: active.toString() } });
    };
    ProjectsService.prototype.removeProject = function (projectId) {
        return this.http.delete(this.projectsUrl + "/" + projectId);
    };
    return ProjectsService;
}());
export { ProjectsService };
